import { create } from "zustand";

interface DateRangeState {
  date: Date;
  setDate: (date: Date) => void;
}

export const useDateRangeStore = create<DateRangeState>()((set) => ({
  date: new Date(),
  setDate: (date) =>
    set(() => ({
      date,
    })),
}));
